var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.accordions),function(accordion){return _c('MUIAccordion',{key:accordion.title,ref:"accordion",refInFor:true,attrs:{"title":accordion.title,"text":accordion.text},on:{"accordion-toggle":_vm.handleAccordionOpen}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }